export default {"src":"/_next/static/media/sliderHandle.3724ec19.svg","height":462,"width":49};